import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-checkbox-list-item",
    styleUrl: "checkbox-list-item.scss"
})
export class CheckboxListItem {
    @Element() element!: HTMLUxCheckboxListItemElement;

    /**
     * this value is used on the checkbox inside this item
     */
    @Prop({ reflect: true }) readonly value: string;
    /**
     * This is the label that is displayed for this item inside the dropdown
     */
    @Prop({ reflect: true }) readonly label: string;
    /**
     * name which is used for checkbox groups or as identifier in forms
     */
    @Prop({ reflect: true }) readonly name: string = "";
    /**
     * indicates if the checkbox is checked
     */
    @Prop() readonly checked: boolean = false;
    /**
     * indicates if the checkbox is disabled
     */
    @Prop() readonly disabled: boolean = false;
    /**
     * indicates if the checkbox has an error state
     */
    @Prop() readonly errorMsg: string;
    /**
     * indicates if the checkbox has an error state
     */
    @Prop() readonly error: boolean = false;
    /**
     * the inputId to be passed down to the ux-checkbox
     */
    // @ts-expect-error Check for typing
    @Prop() readonly inputId: string = null;

    /**
     * redispatches the uxCheckboxChange event, otherwise not interceptable in SPAs
     */
    @Event({
        eventName: "uxCheckboxListItemChange",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    checkboxListItemEvent!: EventEmitter;

    private dispatchCheckboxListItemChange = (e: CustomEvent) => {
        this.checkboxListItemEvent.emit(e.detail);
    };

    render() {
        const baseClass = "ux-checkbox-list-item";
        return (
            <Host class={baseClass}>
                <ux-checkbox
                    value={this.value}
                    label={this.label}
                    name={this.name}
                    checked={this.checked}
                    disabled={this.disabled}
                    onUxCheckboxChange={this.dispatchCheckboxListItemChange}
                    error={this.error}
                    errorMsg={this.errorMsg}
                    // @ts-expect-error Check for typing
                    inputId={this.inputId || null}
                >
                    <slot />
                </ux-checkbox>
            </Host>
        );
    }
}
